import Typography from '@mui/material/Typography';
import {memo} from 'react';
import {useTheme} from '@mui/material/styles';

const MUITypography = (props: any): any => {
    const {variant, component, className, children, sx, ...rest} = props;

    const theme = useTheme();

    // Prepend the default font-family while preserving `sx` in whatever form it
    // was passed. An array `sx` (e.g. sx={[base, override]}) must stay an array —
    // spreading it into an object would turn it into {0: …, 1: …} and MUI would
    // drop every style. Array form also avoids shallow-merge collisions between
    // composed style objects (e.g. two `&:hover` blocks).
    const fontFamilySx = {fontFamily: theme.typography.fontFamily};
    const defaultSx = Array.isArray(sx) ? [fontFamilySx, ...sx] : {...fontFamilySx, ...sx};

    /**
     * IMPORTANT:
     * MUI Typography defaults to rendering <p>.
     *
     * That causes hydration issues if html-react-parser injects:
     * div / p / ul / ol etc inside Typography.
     *
     * So we default to <div> unless explicitly overridden.
     */
    const resolvedComponent = component || 'div';

    return (
        <Typography variant={variant} component={resolvedComponent} className={className} sx={defaultSx} {...rest}>
            {children}
        </Typography>
    );
};

export default memo(MUITypography);
